let promise;            // 1) shared cache

export async function useGsap () {
  if (!promise) {
    promise = Promise.all([
      import('gsap'),
      import('gsap/ScrollTrigger')
    ]).then(([{ gsap }, { default: ScrollTrigger }]) => {
      gsap.registerPlugin(ScrollTrigger);
      return { gsap, ScrollTrigger };
    });
  }
  return promise;
}

/* 2) Mini-Helper zum *späten* Starten -------------------------- */
export function runAfterLoad(callback) {
  const schedule = () => {
    (window.requestAnimationFrame || ((cb) => setTimeout(cb, 16)))(callback);
  };

  if (document.readyState === 'complete') {
    schedule();
    return;
  }

  window.addEventListener('load', schedule, { once: true });
}

export function withGsap (callback, { timeout = 2000 } = {}) {
  // Mobile / Touch?  ->  gar nicht laden
  if (!matchMedia('(hover: hover)').matches) return;

  const idle = window.requestIdleCallback || (cb => setTimeout(cb, 1));

  idle(async () => {
    const api = await useGsap();
    callback(api);            // Animation-Code ausführen
  }, { timeout });
}
